v3<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<div id="content" class="app-content box-shadow-3 scroll-x">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-light bg-white b-b">
					<div class="flex navbar-breadcrumbs">
						<a class="text-muted" href="/#/classes">Classes	</a>
						<i class="far fa-fw fa-angle-right text-muted" />
						<span v-if="classObj">{{ classObj.name }}</span>
						<span v-if="!classObj">
							<loading type="inline-header" />
						</span>
					</div>
					<a class="btn-nav-topright b-l ml-0" href="/#/classes">
						<div>
							<i class="fas fa-arrow-alt-left fa-fw" />
							Back
						</div>
					</a>
					<a class="btn-nav-topright b-l ml-0" href="/#/landing">
						<div>
							<i class="fas fa-th-large fa-fw" />
							Home
						</div>
					</a>
				</div>

				<div class="content-main">
					<div v-if="classObj" class="row m-0 align-items-stretch">
						<div class="col-12 col-sm-8 padding d-flex flex-column">
							<div class="d-flex flex-row align-items-center mb-3">
								<h5 v-if="classObj.deliveries && classObj.deliveries.length" class="flex ml-2 mb-0">
									Assessments
								</h5>
								<h3
									v-if="!classObj.deliveries || !classObj.deliveries.length"
									class="flex ml-2 mb-0 text-very-muted"
								>
									No assessments
								</h3>
								<button class="btn theme text-white mr-3" @click="openAddModal()">
									<i class="fas fa-plus mr-1" />
									Add Assessment
								</button>
							</div>

							<div
								v-if="assessments && assessments.length"
								class="box clickable d-flex flex-row align-items-stretch"
								@click="goToAssessment(asmt.id)"
								v-for="asmt in assessments"
								:key="asmt.id"
							>
								<div class="img-square">
									<img :src="asmt.content_area.image_url" />
								</div>
								<div class="flex d-flex flex-column b-l b-r">
									<h6 class="py-2 px-3 mb-0">{{ asmt.name }}</h6>
									<table>
										<tr v-for="deliv in asmt.deliveries" :key="deliv.id" class="b-t">
											<td class="px-3 py-1">
												<span class="text-muted">{{ deliv.name }}</span>
												<span v-if="deliv.pretest" class="badge success">Pre</span>
												<span v-if="deliv.posttest" class="badge success">Post</span>
											</td>
											<td style="width: 60%" class="pr-3">
												<div class="progress">
													<div
														class="progress-bar progress-bar-striped bg-success"
														role="progressbar"
														:style="{ width: `${deliv.completePer}%` }"
														v-tippy
														:title="
															`Scored: ${deliv.completePer}% (${deliv.complete} out of ${deliv.total})`
														"
													></div>
													<div
														class="progress-bar progress-bar-striped bg-primary"
														role="progressbar"
														:style="{ width: `${deliv.differencePer}%` }"
														v-tippy
														:title="
															`Work Uploaded: ${deliv.uploadedPer}% (${deliv.uploaded} out of ${deliv.total})`
														"
													></div>
												</div>
											</td>
											<td>
												<a
													class="clickable-text my-1 mr-2"
													@click.stop="showDeleteDelivery(asmt, deliv)"
													v-tippy
													title="Delete Administration"
												>
													<i class="fas fa-trash mr-1" />
												</a>
											</td>
										</tr>
									</table>
								</div>

								<div class="px-3 py-2 d-flex flex-column align-self-end">
									<a
										class="btn btn-sm btn-icon btn-rounded danger text-white my-1 mr-1"
										@click.stop="showDeleteAssessment(asmt)"
										v-tippy
										title="Delete Assessment"
									>
										<i class="fas fa-trash mr-1" />
									</a>
									<a
										class="btn btn-sm btn-icon btn-rounded theme text-white my-1 mr-1"
										@click.stop="openEditModal(asmt)"
										v-tippy
										title="Edit Administrations"
									>
										<i class="fas fa-pencil mr-1" />
									</a>
									<a
										:id="`resourcesDropdown-${asmt.id}`"
										class="btn btn-sm btn-icon btn-rounded theme text-white my-1 mr-1"
										@click.stop="openResourcesDropdown(asmt.id)"
										data-toggle="dropdown"
										aria-expanded="false"
										v-tippy
										title="Resources"
									>
										<i class="fas fa-external-link mr-1" />
									</a>
									<div
										class="dropdown-menu dropdown-menu-right"
										v-if="asmt.item && asmt.item.resources"
									>
										<a
											v-for="resource in asmt.item.resources"
											:key="resource.id"
											class="dropdown-item"
											@click.stop="viewResource(asmt.id, resource)"
										>
											<i class="fas fa-lg fa-file-alt"></i>
											<label class="mb-0">{{ resource.name }}</label>
										</a>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 col-sm-4 padding d-flex flex-column">
							<div class="d-flex flex-row align-items-center mb-3">
								<h5 class="flex ml-2 mb-0">Students</h5>
								<button class="btn theme text-white" data-toggle="dropdown" aria-expanded="false">
									<i class="fas fa-ellipsis-v faw"></i>
								</button>
								<div class="dropdown-menu dropdown-menu-right">
									<a
										class="dropdown-item d-flex flex-row align-items-center"
										target="_blank"
										:href="`#/class/qr/${classObj.id}`"
										style="height: 36px;"
									>
										<i class="fas fa-lg fa-qrcode fa-fw" style="opacity: 1;"></i>
										<label class="mb-0">Print QR Codes</label>
									</a>
									<a
										class="dropdown-item d-flex flex-row align-items-center"
										target="_blank"
										:href="`#/class/${classObj.id}/all_results/print`"
										style="height: 36px;"
									>
										<i class="fas fa-lg fa-print fa-fw" style="opacity: 1;"></i>
										<label class="mb-0">Print All Student Results</label>
									</a>
								</div>
								<!-- <a v-if="classObj" target="_blank" :href="'#/class/qr/'+ classObj.id" class="btn" title="Print QR Codes" v-tippy><i class="fas fa-qrcode"></i></a> -->

								<button
									class="btn theme text-white mr-3 ml-3"
									data-toggle="modal"
									data-target="#addStudentModal"
								>
									<i class="fas fa-plus mr-1" />
									Add Student(s)
								</button>
							</div>
							<div class="card box">
								<table>
									<tr v-if="!students || !students.length" class="student-row">
										<td class="px-3 text-center" colspan="2">
											<span class="text-extra-muted">No students</span>
										</td>
									</tr>
									<tr
										v-if="students && students.length"
										class="student-row"
										v-for="student in sortedStudents"
										:key="student.id"
									>
										<td class="b-b pl-3">
											<i class="fas fa-lg fa-user mr-2"></i>
											<span>{{ student.full_name }}</span>
										</td>
										<td style="width: 1px;" class="v-mid b-b pr-2">
											<div class="d-flex flex-row">
												<a
													class="btn-round-subtle mr-0"
													v-tippy
													title="Edit Student"
													@click="openEditStudentModal(student)"
												>
													<i class="fas fa-edit" />
												</a>
												<a
													class="btn-round-subtle mr-0"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													<i class="fas fa-ellipsis-v" />
												</a>
												<div class="dropdown-menu dropdown-menu-right">
													<a class="dropdown-item" @click="attemptRemoveStudent(student)">
														<i class="fas fa-trash"></i>
														<label class="mb-0">Remove Student</label>
													</a>
													<a
														class="dropdown-item"
														:href="`/#/class/${classObj.id}/student/${student.id}/results`"
													>
														<i class="fas fa-chart-bar"></i>
														<label class="mb-0">View Student's Results</label>
													</a>
												</div>
											</div>
										</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="addStudentModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="mb-0">Add Students</h5>
					</div>
					<div class="modal-body">
						<div v-if="district">
							<div>
								<label>Search</label>
								<config-student-search v-model="studentSearch" :districtID="district.id" />
							</div>
						</div>
						<div class="clickable-links d-flex flex-row justify-content-end text-extra-muted">
							<a href="/static/templates/Class Roster Template - Add Students to Class.csv" download>
								Download template...
							</a>
						</div>
						<div
							class="dropzone clickable p-3 card"
							:class="{ dropping: droppingFile }"
							@drop.prevent="doDropStudentFiles"
							@dragenter="addDropStudentFiles"
							@dragleave="removeDropStudentFiles"
							@dragover.prevent
							@click="click('file-input')"
						>
							<input
								id="file-input"
								class="d-none"
								type="file"
								accept=".csv"
								@change="selectImportFile"
							/>
							<h3 class="text-very-muted text-center my-4 no-pointer">
								{{ droppingFile ? "Release to upload..." : "Drag or click to upload..." }}
							</h3>
						</div>
						<hr class="modal-divider" />
						<div class="form-group">
							<label>Add</label>
							<div v-for="(student, i) in addingStudents" :key="i" v-if="!student.exists">
								<div class="d-flex flex-row align-items-center">
									<!-- Validation alerts -->
									<a
										v-if="student.match"
										class="btn-subtle mr-1 student-alert-btn"
										v-tippy
										:title="
											`Matched existing student.<br />Click here if you would like to create a duplicate student with the same name.`
										"
										@click="convertToNewStudent(student)"
									>
										<i class="fas fa-user-check fa-lg text-success" style="margin-left: 2px;" />
									</a>
									<a
										v-if="student.partial_name && student.partial_name.exists"
										class="btn-subtle mr-1 student-alert-btn"
										v-tippy
										:title="
											`A student named '${student.first_name} ${student.last_name}' is already enrolled in this class with ID '${student.partial_name.ref_id}'.<br />Edit the information, or click here to remove this row.`
										"
										@click="removeStudentRow(i)"
									>
										<i class="fas fa-exclamation-circle fa-lg text-warning error-icon" />
									</a>
									<a
										v-if="student.partial_name && !student.partial_name.exists"
										class="btn-subtle mr-1 student-alert-btn"
										v-tippy
										:title="
											`A student named '${student.first_name} ${student.last_name}' already exists with ID '${student.partial_name.ref_id}'.<br />Click here to use the existing student.`
										"
										@click="convertToExistingStudent(student, student.partial_name)"
									>
										<i class="fas fa-exclamation-circle fa-lg text-warning error-icon" />
									</a>
									<a
										v-if="student.partial_id"
										class="btn-subtle mr-1 student-alert-btn"
										v-tippy
										:title="
											`A student with ID '${student.ref_id}' already exists as '${student.partial_id.first_name} ${student.partial_id.last_name}'.<br />Click here to use the existing student.`
										"
										@click="convertToExistingStudent(student, student.partial_id)"
									>
										<i class="fas fa-exclamation-circle fa-lg text-danger error-icon" />
									</a>
									<div
										v-if="!(student.match || student.partial_name || student.partial_id)"
										class="mr-1 student-alert-btn"
									>
										<i
											v-if="!(validated && allValid && !adding)"
											class="fas fa-user fa-lg text-very-muted"
										/>
										<i
											v-if="validated && allValid && !adding"
											class="fas fa-user-check fa-lg text-very-muted"
											style="margin-left: 2px;"
										/>
									</div>

									<!-- Input fields -->
									<input
										@input="changedStudentName(student)"
										class="form-control"
										style="flex-basis: 20%; height: 36px;"
										placeholder="First name"
										v-model="student.first_name"
										:disabled="hasID(student)"
									/>
									<input
										@input="changedStudentName(student)"
										class="form-control"
										style="flex-basis: 20%; height: 36px;"
										placeholder="Last name"
										v-model="student.last_name"
										:disabled="hasID(student)"
									/>
									<input
										@input="changedStudentID(student)"
										class="form-control"
										style="flex-basis: 20%; height: 36px;"
										placeholder="Student ID"
										v-model="student.ref_id"
										:disabled="hasID(student)"
									/>
									<input
										@input="changedStudent(student)"
										class="form-control"
										style="flex-basis: 28%; height: 36px;"
										:placeholder="
											district && district.require_emails ? 'Email' : 'Email (optional)'
										"
										v-model="student.email"
										:disabled="hasID(student)"
									/>
									<div class="ml-2" style="flex-basis: 80px;">
										<button
											class="btn btn-sm btn-icon btn-rounded danger"
											@click="removeStudentRow(i)"
										>
											<i class="fas fa-minus" />
										</button>
										<button
											v-if="i == addingStudents.length - 1"
											class="btn btn-sm btn-icon btn-rounded success"
											@click="addStudentRow(i)"
										>
											<i class="fas fa-plus" />
										</button>
									</div>
								</div>
								<div v-if="student.error" class="d-flex flex-row align-items-center">
									<i class="fas fa-exclamation-triangle text-danger error-icon" />
									{{ student.error }}
								</div>
							</div>
							<div v-for="(student, i) in addingStudents" :key="i" v-if="student.exists">
								<i class="fas fa-exclamation-circle error-icon" />
								{{ student.first_name }} {{ student.last_name }} is already part of this class
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div v-show="validated && !allValid" class="flex">
							You must resolve all issues marked with
							<i class="fas fa-exclamation-triangle text-danger error-icon mr-0" />
							before you can continue.
						</div>

						<button class="btn btn-flat" @click="hideAddModal">Cancel</button>
						<button v-show="!validated && !validating" class="btn btn-flat theme" @click="validateStudents">
							Validate
						</button>
						<button v-show="!validated && validating" class="btn btn-flat theme" disabled>
							Validating...
							<loading type="icon" />
						</button>
						<button
							v-show="validated && allValid && !adding"
							class="btn btn-flat btn-success"
							@click="doAddStudents"
							:disabled="!anyStudents"
						>
							Add
						</button>
						<button v-show="validated && !allValid" class="btn btn-flat btn-secondary" disabled>Add</button>
						<button v-show="adding" class="btn btn-flat btn-success" disabled>
							Adding...
							<loading type="icon" />
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="editStudentModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content" v-if="editStudent">
					<div class="modal-header">
						<h5 class="mb-0">Edit Student - {{ editStudent.first_name }} {{ editStudent.last_name }}</h5>
					</div>
					<div class="modal-body">
						<div class="row m-0">
							<small class="form-group col-12 form-text text-muted">
								Note: Changes to this student's information will apply to all other classes in which the
								student is enrolled.
							</small>
							<div class="form-group col-6">
								<label>First Name</label>
								<input class="form-control" type="text" v-model="editStudent.first_name" />
							</div>
							<div class="form-group col-6">
								<label>Last Name</label>
								<input class="form-control" type="text" v-model="editStudent.last_name" />
							</div>
							<div class="form-group col-6">
								<label>Student ID</label>
								<input class="form-control" type="text" v-model="editStudent.ref_id" />
							</div>
							<div class="form-group col-6">
								<label v-if="district.require_emails">Email</label>
								<label v-if="!district.require_emails">Email (optional)</label>
								<input class="form-control" type="text" v-model="editStudent.email" />
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div v-show="editStudent.error" class="flex">
							<i class="fas fa-exclamation-triangle text-danger error-icon" />
							{{ editStudent.error }}
						</div>

						<button class="btn btn-flat" @click="hideEditStudentModal">Cancel</button>
						<button
							v-show="!editSaving && !editStudent.error"
							class="btn btn-flat btn-success"
							@click="saveEditStudent"
						>
							Save
						</button>
						<button v-show="!editSaving && editStudent.error" class="btn btn-flat btn-secondary" disabled>
							Save
						</button>
						<button v-show="editSaving" class="btn btn-flat btn-success" disabled>
							Saving...
							<loading type="icon" />
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="addAssessmentModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="mb-0">Add Assessment</h5>
					</div>
					<div class="modal-body">
						<form role="form">
							<div class="d-flex flex-row form-group">
								<div class="flex">
									<label>Content Area</label>
									<v-select
										multiple
										label="name"
										class="bg-white"
										:options="areas"
										v-model="sAreas"
									></v-select>
								</div>
								<div class="flex ml-2">
									<label>Grade</label>
									<v-select
										multiple
										label="name"
										class="bg-white"
										:options="grades"
										v-model="sGrades"
									></v-select>
								</div>
							</div>
							<div class="form-group">
								<label>Assessment</label>
								<config-assessment-search :contentAreas="sAreas" :grades="sGrades" v-model="asmt" />
							</div>
							<div class="form-group">
								<label>Administration Name</label>
								<input type="text" class="form-control" v-model="asmtName" />
							</div>
							<div class="checkbox form-group d-flex flex-row">
								<label class="md-check">
									<input v-model="asmtPretest" type="checkbox" />
									<i class="theme-accent"></i> Pre-test
								</label>
								<label class="md-check ml-3">
									<input v-model="asmtPosttest" type="checkbox" />
									<i class="theme-accent"></i> Post-test
								</label>
							</div>
							<template v-if="asmtItem && asmtItem.use_considerations">
								<hr />
								<div class="form-group">
									<label>Administration Notes</label>
									<small class="form-text text-muted">
										These notes will be displayed to any user scoring work from this assessment.
									</small>
									<RichText :text.sync="asmtNotes" :init="asmtNotesInit" :options="{ height: 104 }" />
								</div>
							</template>
							<template>
								<hr />
								<div class="form-group">
									<label>Students Notes</label>
									<small class="form-text text-muted">
										These notes will be displayed to students when they're submitting work this assessment.
									</small>
									<RichText :text.sync="studentNotes" :init="studentNotesInit" :options="{ height: 104 }" />
								</div>
							</template>
						</form>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat" data-dismiss="modal">Cancel</button>
						<button class="btn btn-flat theme" data-dismiss="modal" @click="addAsmt()">Add</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="editAssessmentModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="mb-0">Edit Assessment</h5>
					</div>
					<div class="modal-body">
						<form role="form" class>
							<div class="form-group">
								<label>Assessment</label>
								<config-assessment-search v-model="asmt" disabled />
							</div>
							<div v-for="deliv in asmtDeliveries" :key="deliv.id" class="row">
								<div :class="{ [asmtItem && asmtItem.use_considerations ? 'col-4' : 'col-12']: true }">
									<div class="form-group">
										<label>Administration Name</label>
										<input type="text" class="form-control" v-model="deliv.name" />
									</div>
									<div class="checkbox form-group d-flex flex-row">
										<label class="md-check">
											<input v-model="deliv.pretest" type="checkbox" />
											<i class="theme-accent"></i> Pre-test
										</label>
										<label class="md-check ml-3">
											<input v-model="deliv.posttest" type="checkbox" />
											<i class="theme-accent"></i> Post-test
										</label>
									</div>
								</div>
								<div class="col-8" v-if="asmtItem && asmtItem.use_considerations">
									<div class="form-group">
										<label>Administration Notes</label>
										<small class="form-text text-muted">
											These notes will be displayed to any user scoring work from this assessment.
										</small>
										<RichText
											:text.sync="deliv.item_notes"
											:initial="deliv.item_notes_init"
											:options="{ height: 104 }"
										/>
									</div>
								</div>
								<hr />
							</div>
						</form>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat" data-dismiss="modal">Cancel</button>
						<button class="btn btn-flat theme" data-dismiss="modal" @click="saveDeliveries()">Save</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="deleteAssessmentModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content" v-if="deletingAsmt">
					<div class="modal-header">
						<h5 class="mb-0">Delete Assessment</h5>
					</div>
					<div class="modal-body">
						<div class="row px-4 py-2 text-md">
							<h5 class="py-2">
								Are you sure you want to delete the assessment
								<strong class="text-theme">"{{ deletingAsmt.name }}"</strong>, including following
								administrations?
								<br />
							</h5>
							<ul>
								<li v-for="deliv in deletingAsmt.deliveries" :key="deliv.id" class="text-theme">
									{{ deliv.name }}
								</li>
							</ul>
							<h6 class="py-2">
								<span class="text-danger far faw fa-exclamation-triangle"></span>
								The operation will occur immediately, cannot be canceled or reversed, and will
								permanently delete all student work and scores in these administrations!
							</h6>
						</div>
						<div class="form-group pl-2 pr-3">
							<input type="text" v-model="deleteAsmtConfirm" class="form-control" />
							<small class="text-muted">To confirm, type the name of the assessment</small>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat" data-dismiss="modal">Cancel</button>
						<button
							class="btn btn-flat"
							:class="{ [deletingAsmt.name != deleteAsmtConfirm ? 'btn-secondary' : 'btn-danger']: true }"
							data-dismiss="modal"
							@click="deleteAssessment(deletingAsmt)"
							:disabled="deletingAsmt.name != deleteAsmtConfirm"
						>
							Delete
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="deleteDeliveryModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content" v-if="deletingDeliv">
					<div class="modal-header">
						<h5 class="mb-0">Delete Administration</h5>
					</div>
					<div class="modal-body">
						<div class="row px-4 py-2 text-md">
							<h5 class="py-2">
								Are you sure you want to delete your administration
								<strong class="text-theme">"{{ deletingDeliv.name }}"</strong>
								of the assessment {{ deletingAsmt.name }}?
								<br />
							</h5>
							<h6 class="py-2">
								<span class="text-danger far faw fa-exclamation-triangle"></span>
								The operation will occur immediately, cannot be canceled or reversed, and will
								permanently delete all student work and scores in this administration!
							</h6>
						</div>
						<div class="form-group pl-2 pr-3">
							<input type="text" v-model="deleteDelivConfirm" class="form-control" />
							<small class="text-muted">To confirm, type the name of the administration</small>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat" data-dismiss="modal">Cancel</button>
						<button
							class="btn btn-flat"
							:class="{
								[deletingDeliv.name != deleteDelivConfirm ? 'btn-secondary' : 'btn-danger']: true
							}"
							data-dismiss="modal"
							@click="deleteDelivery(deletingDeliv)"
							:disabled="deletingDeliv.name != deleteDelivConfirm"
						>
							Delete
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="uploadWorkModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5>Upload Work</h5>
					</div>
					<div class="modal-body">
						<div class="row m-0">
							<div class="col-6">
								<div class="p-3 card">
									<table>
										<tr class="student-row" v-for="student in students" :key="student.id">
											<td class="b-b">
												<i class="fas fa-lg fa-user mr-2"></i>
												<span>{{ student.name }}</span>
											</td>
											<td style="width: 1px;" class="v-mid b-b">
												<div class="d-flex flex-row">
													<a class="btn-round-subtle mr-0" v-tippy title="Edit Student">
														<i class="far fa-file-upload" />
													</a>
												</div>
											</td>
										</tr>
									</table>
								</div>
							</div>
							<div class="col-6 align-self-stretch">
								<div
									class="p-3 card h-100"
									@drop.prevent="doDropFiles"
									@dragenter="addDropFiles"
									@dragleave="removeDropFiles"
									@dragover.prevent
								>
									<table>
										<draggable
											v-if="newWork.length > 0"
											v-model="newWork"
											:options="{ handle: '.drag-handle' }"
											class="w-100"
										>
											<tr
												class="student-row v-mid w-100"
												v-for="(work, index) in newWork"
												:key="index"
											>
												<td class="m-auto px-2 drag-handle flex-fixed b-b">
													<i class="far fa-sort text-muted"></i>
												</td>
												<td class="b-b w-100">
													<i class="fas fa-lg fa-file-upload mr-2"></i>
													<span>{{ work.file.name }}</span>
												</td>
												<td style="width: 1px;" class="v-mid b-b">
													<div class="d-flex flex-row">
														<a class="btn-round-subtle mr-0" v-tippy title="Delete work">
															<i class="fas fa-trash" />
														</a>
													</div>
												</td>
											</tr>
										</draggable>
									</table>
									<!-- <div v-for="(work, index) in newWork" :key="index" class="student-row">
										<div class="d-flex">
											<div class="m-auto px-2 drag-handle flex-fixed">
												<i class="far fa-sort text-muted"></i>
											</div>
											<div class="pr-2 flex">
												<small class="text-muted">File: {{work.file.name}}</small>
											</div>
											<div class="m-auto pr-2" style="flex-grow: 0;" v-show="work.uploading" v-tippy title="Uploading">
												<loading type="icon" />
											</div>
											<div class="m-auto pr-2" style="flex-grow: 0;">
												<button class="btn btn-sm btn-icon btn-rounded hover-darken red text-white m-0" v-tippy title="Delete">
													<i class="far fa-trash"></i>
												</button>
											</div>
										</div>
									</div>-->
									<h3 v-if="newWork.length == 0" class="text-very-muted text-center mt-5">
										Drag work here...
									</h3>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat" data-dismiss="modal">Cancel</button>
						<button class="btn btn-flat theme">Upload</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="removeStudentModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content" v-if="removingStudent">
					<div class="modal-header">
						<h5>Remove Student - {{ removingStudent.full_name }}</h5>
					</div>
					<div class="modal-body">
						<div class="row p-4">
							Are you sure you want to delete&nbsp;
							<strong class="text-theme">{{ removingStudent.full_name }}</strong
							>?
							<br />
							<br />
							<p class="text-danger">
								<i class="fas fa-exclamation-triangle error-icon" />
								The student's work and scores in this class will be permanently deleted.
							</p>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat" data-dismiss="modal">Cancel</button>
						<button v-show="!removing" class="btn btn-flat theme" @click="doRemoveStudent">Remove</button>
						<button v-show="removing" class="btn btn-flat theme" disabled>
							Removing...
							<loading type="icon" />
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="noStudentsErrorModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5>No Students</h5>
					</div>
					<div class="modal-body">
						<div class="row p-4">You must add students to this class first.</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat theme" data-dismiss="modal">Okay</button>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.student-row {
	height: 36px;
}
.curved-br {
	border-bottom-right-radius: 0.75rem;
}
progress[value] {
	/* Reset the default appearance */
	-webkit-appearance: none;
	appearance: none;

	width: 250px;
	height: 20px;
}
progress[value]::-webkit-progress-bar {
	background-color: #eee;
	border-radius: 2px;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
}
progress[value]::-webkit-progress-value {
	background-image: -webkit-linear-gradient(
			-45deg,
			transparent 33%,
			rgba(0, 0, 0, 0.1) 33%,
			rgba(0, 0, 0, 0.1) 66%,
			transparent 66%
		),
		-webkit-linear-gradient(top, rgba(255, 255, 255, 0.25), rgba(0, 0, 0, 0.25)),
		-webkit-linear-gradient(left, rgb(115, 154, 212), rgb(145, 194, 252));

	border-radius: 2px;
	background-size: 35px 20px, 100% 100%, 100% 100%;
}
.img-square {
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.img-square > img {
	height: 120px;
	width: 120px;
	object-fit: cover;
	object-position: center top;
}
.clickable {
	cursor: pointer;
	transition: background-color 0.1s ease-in-out;
}
.clickable:hover {
	background-color: rgb(0, 0, 0, 0.1);
}
.clickable img {
	transition: filter 0.1s ease-in-out;
}
.clickable:hover img {
	filter: brightness(85%);
}
.modal-divider {
	margin-left: -1rem;
	margin-right: -1rem;
}
.no-pointer {
	pointer-events: none;
}
.dropping {
	background-color: rgb(0, 0, 0, 0.1);
}
.comma-separated:not(:last-child):after {
	margin-left: -3px;
	content: ", ";
}
.clickable-links a {
	text-decoration: underline;
	color: darkblue;
	margin-left: 0.25rem;
	margin-right: 0.25rem;
	-webkit-user-select: none;
	-moz-user-select: none;
	user-select: none;
}
.clickable-links a:hover {
	text-decoration: underline;
	color: blue;
}
.error-icon {
	margin-right: 3px;
	margin-left: 3px;
}
.disabled-mouseover {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0px;
	left: 0px;
}
a.btn-subtle {
	transition: background-color 0.25s;
	border-radius: 2rem;
}
a.btn-subtle:hover {
	background-color: rgb(0, 0, 0, 0.1);
}
.student-alert-btn {
	width: 32px;
	min-width: 32px;
	text-align: center;
	padding: 4px;
	margin: -4px;
}

.clickable-text {
	transition: color 0.1s ease-in-out;
}
.clickable-text:hover {
	color: rgba(35, 45, 55, 1) !important;
}
</style>

<script>
import ClassService from "@/services/ClassService";
import StudentService from "@/services/StudentService";
import ContentAreaService from "@/services/ContentAreaService";
import GradeService from "@/services/GradeService";
import ReportingService from "@/services/ReportingService";
import ResourceService from "@/services/ResourceService";
import FileService from "@/services/FileService";
import ValidationPatternService from "@/services/ValidationPatternService";
import Notie from "@/services/NotieService";

import ConfigStudentSearch from "@/components/ConfigStudentSearch";
import ConfigAssessmentSearch from "@/components/ConfigAssessmentSearch";
import RichText from "@/components/RichText";
import draggable from "vuedraggable";
import $ from "jquery";
import BB from "bluebird";

export default {
	name: "Class",

	props: ["user"],

	data() {
		return {
			classObj: null,
			students: [],
			assessments: null,
			district: null,

			deliveryID: null,
			asmtName: null,
			asmt: null,
			asmtPretest: false,
			asmtPosttest: false,
			asmtNotes: null,
			asmtNotesInit: null,
			asmtItem: null,
			studentNotes: null,
			studentNotesInit: null,

			areas: [],
			sAreas: null,
			grades: [],
			sGrades: null,

			asmtDeliveries: [],
			completion: [],

			studentSearch: null,
			addingStudents: [{}],
			validating: false,
			validated: false,
			allValid: false,
			adding: false,

			editStudent: null,
			editSaving: false,

			removingStudent: null,
			removing: false,

			deletingAsmt: null,
			deleteAsmtConfirm: null,

			deletingDeliv: null,
			deleteDelivConfirm: null,

			newWork: [],
			droppingFiles: false,
			droppingFile: false
		};
	},
	components: {
		draggable,
		RichText,
		ConfigStudentSearch,
		ConfigAssessmentSearch
	},

	watch: {
		asmt() {
			if (this.asmt) {
				this.asmtName = this.asmt.name;
				if (this.asmt.assessment_items && this.asmt.assessment_items.length) {
					this.asmtItem = this.asmt.item;
				} else {
					this.asmtItem = null;
				}
			} else {
				this.asmtName = "";
				this.asmtItem = null;
			}
		},
		studentSearch() {
			if (this.studentSearch) {
				this.clearEmptyStudentRows();
				let exists = _.find(this.addingStudents, {
					id: this.studentSearch.id
				});
				if (!exists) {
					this.addingStudents.push(this.studentSearch);
					this.studentSearch = null;
				}
			}
		}
	},

	computed: {
		anyStudents() {
			let any = false;
			_.each(this.addingStudents, s => {
				if (!s.exists && (s.first_name || s.last_name || s.ref_id)) {
					any = true;
				}
			});
			return any;
		},

		sortedStudents() {
			return _.orderBy(this.students, ["last_name", "first_name"], ["asc", "asc"]);
		}
	},

	created() {
		this.loadData();
	},
	methods: {
		loadData() {
			return BB.props({
				class: ClassService.getClassAndAssessments(this.$route.params.classID),
				students: StudentService.listStudentsFromClass(this.$route.params.classID),
				contentAreas: ContentAreaService.listContentAreas(),
				grades: GradeService.listGrades(),
				completion: ReportingService.getClassCompletion(this.$route.params.classID)
			})
				.then(resps => {
					this.classObj = resps.class.data.class;
					console.log(this.classObj);
					this.assessments = resps.class.data.assessments;
					this.district = resps.class.data.district;
					if (this.district.validation_pattern) {
						this.district.id_regex = ValidationPatternService.getRegex(this.district.validation_pattern);
					}
					this.distributeDeliveries(this.classObj, this.assessments);

					this.students = resps.students.data.students;

					this.areas = resps.contentAreas.data.content_areas;
					this.sAreas = [];
					_.each(this.user.content_area_ids, caid => {
						let area = _.find(this.areas, { id: caid });
						if (area) {
							this.sAreas.push(area);
						}
					});

					this.grades = resps.grades.data;
					this.sGrades = [];
					_.each(this.user.grade_ids, gid => {
						let grade = _.find(this.grades, { id: gid });
						if (grade) {
							this.sGrades.push(grade);
						}
					});

					this.completion = resps.completion.data;
					this.loadCompletionStats();
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to load class", err);
				});
		},

		loadCompletionStats() {
			_.each(this.assessments, asmt => {
				_.each(asmt.deliveries, deliv => {
					let stat = _.find(this.completion, {
						assessment_id: asmt.id,
						delivery_id: deliv.id
					});
					if (stat) {
						deliv.total = this.students.length;
						deliv.uploaded = stat.uns + stat.rel + stat.res + stat.com;
						deliv.uploadedPer = ((deliv.uploaded / deliv.total) * 100).toFixed(1);
						deliv.complete = stat.com;
						deliv.completePer = ((deliv.complete / deliv.total) * 100).toFixed(1);
						deliv.difference = deliv.uploaded - deliv.complete;
						deliv.differencePer = ((deliv.difference / deliv.total) * 100).toFixed(1);
					}
				});
			});
		},

		distributeDeliveries(classObj, asmts) {
			_.each(asmts, asmt => {
				let delivs = _.filter(classObj.deliveries, {
					assessment_id: asmt.id
				});
				asmt.deliveries = delivs;
			});
		},

		goToAssessment(asmtID) {
			if (this.students && this.students.length) {
				this.$router.push(`/class/${this.classObj.id}/assessment/${asmtID}`);
			} else {
				$("#noStudentsErrorModal").modal("toggle");
			}
		},

		addNewWork(file) {
			var suggestedName = file.name.split(".");
			if (suggestedName.length > 1) {
				//Pop off the extension if it exists
				suggestedName.pop();
			}
			suggestedName = suggestedName.join("");
			suggestedName = suggestedName.replace(/_/g, " ");

			this.newWork.push({
				name: suggestedName,
				file: file,
				uploading: false
			});

			console.log("___ADD NEW WORK___");
			console.log(file);
		},

		addDropFiles(event) {
			console.log("___FILE ENTER___");
			console.log(event.dataTransfer.files);
			this.droppingFiles = true;
		},

		removeDropFiles(event) {
			console.log("___FILE LEAVE___");
			console.log(event.dataTransfer.files);
			this.droppingFiles = false;
		},

		doDropFiles(event) {
			console.log("___FILE DROP___");
			console.log(event.dataTransfer.files);
			_.each(event.dataTransfer.files, file => {
				this.addNewWork(file);
			});
			this.droppingFiles = false;
		},

		openAddModal(asmt) {
			this.blankAsmt(asmt);
			$("#addAssessmentModal").modal();
		},

		openEditModal(asmt) {
			this.loadAsmt(asmt);
			$("#editAssessmentModal").modal();
		},

		loadAsmt(asmt) {
			this.asmtDeliveries = _.filter(this.classObj.deliveries, {
				assessment_id: asmt.id
			});
			_.each(this.asmtDeliveries, deliv => {
				deliv.item_notes_init = deliv.item_notes;
			});
			this.asmt = asmt;
		},

		blankAsmt() {
			this.deliveryID = null;
			this.asmt = null;
			this.asmtName = null;
			this.asmtPretest = false;
			this.asmtPosttest = false;
			this.asmtNotesInit = null;
			this.studentNotesInit = null;

		},

		addAsmt() {
			let delivery = {
				id: this.deliveryID,
				assessment_id: this.asmt.id,
				name: this.asmtName,
				item_notes: this.asmtNotes,
				students_notes:this.studentNotes,
				pretest: this.asmtPretest,
				posttest: this.asmtPosttest
			};

			ClassService.saveDelivery(this.classObj.id, delivery)
				.then(resp => {
					this.loadData();
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to save assessment", err);
				});
		},

		showDeleteAssessment(asmt) {
			this.deletingAsmt = asmt;
			this.deleteAsmtConfirm = "";
			$("#deleteAssessmentModal").modal();
		},

		showDeleteDelivery(asmt, deliv) {
			this.deletingAsmt = asmt;
			this.deletingDeliv = deliv;
			this.deleteDelivConfirm = "";
			$("#deleteDeliveryModal").modal();
		},

		deleteAssessment(asmt) {
			return ClassService.deleteDeliveriesByAssessment(this.classObj.id, asmt.id)
				.then(resp => {
					this.loadData();
					Notie.info(`${asmt.name} deleted`);
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to delete assessment", err);
				});
		},

		deleteDelivery(delivery) {
			return ClassService.deleteDelivery(this.classObj.id, delivery.id)
				.then(resp => {
					this.loadData();
					Notie.info(`${delivery.name} deleted`);
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to delete assignment", err);
				});
		},

		saveDeliveries() {
			ClassService.saveClass(this.classObj)
				.then(resp => {
					this.loadData();
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to save assessment", err);
				});
		},

		openResourcesDropdown(id) {
			let el = $(`#resourcesDropdown-${id}`);
			console.log(el);
			el.dropdown("toggle");
		},

		addStudentRow() {
			this.addingStudents.push({});
		},

		removeStudentRow(i) {
			this.$delete(this.addingStudents, i);

			if (this.addingStudents.length == 0) {
				this.addingStudents.push({});
			}
			this.validated = false;
			this.allValid = false;
		},

		clearEmptyStudentRows(clearAll) {
			this.addingStudents = _.filter(this.addingStudents, s => {
				return s.first_name || s.last_name || s.id || s.grade;
			});
		},

		doAddStudents() {
			this.clearEmptyStudentRows();
			_.each(this.addingStudents, student => {
				student.district_id = this.classObj.district_id;
				student.client_id = this.classObj.client_id;
			});
			ClassService.saveStudentsToClass(this.classObj.id, this.addingStudents)
				.then(resp => {
					let count = resp.data;
					Notie.info(`${count} ${count > 1 ? "students" : "student"} saved`);
					this.addingStudents = [{}];
					this.loadData().then(() => {
						$("#addStudentModal").modal("toggle");
					});
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to save student(s)", err);
				});
		},

		importStudentRows(file) {
			if (file.type != "text/csv" && file.type != "application/vnd.ms-excel") {
				this.importingFile = null;
				notie.error("File must be CSV!");
				return;
			}

			let reader = new FileReader();
			reader.onload = e => {
				let studentsIn = FileService.CSVToArray(e.target.result);

				let students = [];
				for (var i = 1; i < studentsIn.length; i++) {
					let studentIn = studentsIn[i];
					let grade = _.find(this.grades, { name: studentIn[3] });
					grade = grade || this.grades[0];
					let student = {
						first_name: studentIn[0],
						last_name: studentIn[1],
						ref_id: studentIn[2],
						email: studentIn[4],
						grade: grade,
						grade_id: grade.id
					};
					if (student.first_name || student.last_name || student.ref_id) {
						students.push(student);
					}
				}

				this.validateStudents(students);
			};

			reader.readAsText(file);
		},

		selectImportFile(event) {
			console.log("===CHOOSE FILE===");
			console.log(event.target.files);
			if (event.target.files[0]) {
				this.importingFile = event.target.files[0];
				this.importStudentRows(this.importingFile);
			}
		},

		addDropStudentFiles(event) {
			console.log("___FILE ENTER___");
			console.log(event.dataTransfer.files);
			this.droppingFile = true;
		},

		removeDropStudentFiles(event) {
			console.log("___FILE LEAVE___");
			console.log(event.dataTransfer.files);
			this.droppingFile = false;
		},

		doDropStudentFiles(event) {
			console.log("___FILE DROP___");
			console.log(event.dataTransfer.files);
			_.each(event.dataTransfer.files, file => {
				this.importStudentRows(file);
			});
			this.droppingFile = false;
		},

		validateStudents(newStudents) {
			this.clearEmptyStudentRows();
			let students = _.cloneDeep(this.addingStudents);
			if (newStudents && newStudents.length) {
				students = students.concat(newStudents);
			}
			_.each(students, s => {
				s.grade_id = s.grade && s.grade.id;
			});

			let did = this.classObj.district_id;
			this.validating = true;
			this.allValid = true;
			StudentService.getStudentMatches(students, did).then(resp => {
				this.addingStudents = [];
				_.each(resp.data, matchStat => {
					let student = matchStat.student;
					let existing = _.find(this.students, {
						id: student.id
					});
					if (existing) {
						student.exists = true;
					}
					student.match = matchStat.match;
					if (matchStat.partial_name) {
						student.partial_name = matchStat.partial_name;
						let existing = _.find(this.students, {
							id: student.partial_name.id
						});
						if (existing) {
							student.partial_name.exists = true;
						}
					}
					if (matchStat.partial_id) {
						student.partial_id = matchStat.partial_id;
						console.log("partial id", student);
						this.allValid = false;
					}
					student.grade = _.find(this.grades, {
						id: student.grade_id
					});

					if (!student.ref_id || student.ref_id == "") {
						student.error = "You must enter a student ID";
						console.log("no id", student);
						this.allValid = false;
					} else if (this.district.id_regex && !this.district.id_regex.exec(student.ref_id)) {
						student.error = `Student ID does not match this district's required pattern ("${this.district.validation_pattern}")`;
						console.log("invalid id", student);
						this.allValid = false;
					} else if (!student.first_name || !student.last_name) {
						student.error = "You must enter a name";
						console.log("no name", student);
						this.allValid = false;
					} else if (this.district.require_emails && !student.email) {
						student.error = "You must enter an email address";
						console.log("email address", student);
						this.allValid = false;
					}

					this.clearEmptyStudentRows();
					this.addingStudents.push(student);
					this.validating = false;
					this.validated = true;
				});
			});
		},

		convertToNewStudent(student) {
			delete student.id;
			delete student.exists;
			delete student.match;

			this.validated = false;
			this.allValid = false;
			this.$forceUpdate();
		},

		convertToExistingStudent(student, matchedStudent) {
			student.first_name = matchedStudent.first_name;
			student.last_name = matchedStudent.last_name;
			student.ref_id = matchedStudent.ref_id;
			student.grade_id = matchedStudent.grade_id;
			student.grade = _.find(this.grades, {
				id: student.grade_id
			});
			student.id = matchedStudent.id;
			delete student.partial_name;
			delete student.partial_id;

			this.validated = false;
			this.allValid = false;
		},

		changedStudentName(student) {
			delete student.partial_id;
			this.changedStudent(student);
		},

		changedStudentID(student) {
			delete student.partial_name;
			this.changedStudent(student);
		},

		changedStudent(student) {
			delete student.match;
			delete student.error;
			this.validated = false;
			this.allValid = false;
		},

		hasID(student) {
			if (student.id && student.id != "") {
				return true;
			} else {
				return false;
			}
		},

		hideAddModal() {
			this.addingStudents = [{}];
			this.validated = false;
			this.allValid = false;

			$("#addStudentModal").modal("toggle");
		},

		click(id) {
			console.log("click the thing");
			var el = document.getElementById(id);
			if (el) {
				el.value = "";
				el.click();
			}
		},

		openEditStudentModal(student) {
			this.editStudent = _.cloneDeep(student);

			$("#editStudentModal").modal();
		},

		saveEditStudent() {
			this.editSaving = true;
			StudentService.saveStudent(this.editStudent)
				.then(resp => {
					this.editSaving = false;
					Notie.info("Student updated");
					this.loadData().then(() => {
						this.hideEditStudentModal();
					});
				})
				.catch(err => {
					this.editSaving = false;
					console.log(err);
					Notie.error("Failed to update student information", err);
				});
		},

		hideEditStudentModal() {
			$("#editStudentModal").modal("toggle");
		},

		attemptRemoveStudent(student) {
			this.removingStudent = student;
			$("#removeStudentModal").modal();
		},

		doRemoveStudent() {
			this.removing = true;
			StudentService.removeStudentFromClass(this.removingStudent.id, this.classObj.id)
				.then(resp => {
					Notie.info(`${this.removingStudent.full_name} removed from class`);
					this.loadData().then(() => {
						this.removing = false;
						this.hideRemoveStudentModal();
					});
				})
				.catch(err => {
					this.removing = false;
					console.log(err);
					Notie.error("Failed to remove student from class", err);
				});
		},

		hideRemoveStudentModal() {
			$("#removeStudentModal").modal("toggle");
		},

		viewResource(itemID, resource) {
			if (resource.type == 1) {
				ResourceService.viewResource(itemID, resource);
			} else if (resource.type == 2) {
				ResourceService.viewExternalResource(resource.path);
			}
			else if (resource.type == 4) {
				ResourceService.viewExternalResource(resource.path);
			}
		}
	}
};
</script>





// WEBPACK FOOTER //
// src/vues/Classes/Class.vue